import React from "react";
import { Award } from "lucide-react";

const certs = [
  { code: "ISO 45001", label: "Lead Auditor — Occupational H&S" },
  { code: "ISO 14001", label: "Lead Auditor — Environmental Mgmt" },
  { code: "ISO 9001", label: "Lead Auditor — Quality Mgmt" },
  { code: "NEBOSH IGC", label: "International General Certificate, 2018" },
  { code: "IOSH", label: "Managing Safely" },
  { code: "CPD", label: "Certified Safety Professional (EHS)" },
  { code: "SAP", label: "S/4HANA EHS — Workplace Safety" },
  { code: "Power BI", label: "Data Visualization & EHS Reporting" },
  { code: "ESG", label: "ESG & Carbon Footprint Specialist" },
  { code: "ILO", label: "Fire & Safety" },
  { code: "CAPA / RCA", label: "Root Cause Analysis Practitioner" },
  { code: "MOC", label: "Management of Change Practitioner" },
];

export default function Certifications() {
  return (
    <section
      data-testid="certifications"
      id="certifications"
      className="bg-white border-t border-line"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20 lg:py-28">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between mb-12 gap-6">
          <div>
            <p className="mono-label">Credentials — verified</p>
            <h2 className="font-display text-4xl md:text-5xl uppercase tracking-tight mt-4 leading-[0.95]">
              Audit-grade certifications
              <span className="text-accent-red">.</span>
            </h2>
          </div>
          <div className="flex items-center gap-2 font-mono text-xs text-ink-muted">
            <Award size={16} className="text-accent-amber" />
            12 active credentials
          </div>
        </div>

        <div
          data-testid="certifications-grid"
          className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 border-t border-l border-line"
        >
          {certs.map((c, i) => (
            <div
              key={i}
              data-testid={`cert-${i}`}
              className="border-r border-b border-line p-6 hover:bg-bgalt transition-colors"
            >
              <span className="font-mono text-[10px] text-ink-muted">
                Cert №{String(i + 1).padStart(2, "0")}
              </span>
              <div className="font-display text-lg uppercase mt-2 leading-tight">
                {c.code}
              </div>
              <p className="text-xs text-ink/65 mt-2 leading-relaxed">
                {c.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
